import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Button } from '../../../components';
import { long } from '../common/formatting/date';

export default class NotesModal extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool,
		onClose: PropTypes.func.isRequired,
		onSave: PropTypes.func.isRequired,
		notes: PropTypes.array,
		isSaving: PropTypes.bool
	}

	state = {
		isAddingNote: false,
		note: ''
	}

	notesRef = React.createRef()

	componentDidUpdate(prevProps) {
		if (!this.props.isOpen && prevProps.isOpen) {
			this.setState({ isAddingNote: false, note: '' });
		}
	}

	handleShowNoteField = () => {
		this.setState(
			() => ({ isAddingNote: true }),
			() => {
				this.notesRef.current.focus();
			}
		);
	}

	handleNoteChange = ({ target }) => {
		this.setState({ note: target.value });
	}

	handleSave = () => {
		this.props.onSave(this.state.note);
	}

	render() {
		const { isOpen, onClose, notes = [], isSaving } = this.props;
		const { isAddingNote, note } = this.state;
		return (
			<Modal isOpen={isOpen} contentLabel="ADT Notes" className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<div className="clearfix">
							<div className="pull-right">
								<button className="btn btn-link" onClick={onClose}>
									<em className="fa fa-lg fa-times" />
								</button>
							</div>
							<h3 className="modal-title">
								ADT Notes
							</h3>
						</div>
					</div>
					<div className="modal-body form notes-container">
						{notes.length === 0 && (
							<p>No notes found</p>
						)}
						{notes.map(note => (
							<div key={`${note.adt_id}-${note.id}`} className="panel panel-default">
								<div className="panel-body">
									{note.note}
								</div>
								<div className="panel-footer">{note.name_first} {note.name_last}, {note.credentials} - {long(note.created_dttm)}</div>
							</div>
						))}
						{isAddingNote && (
							<div className="form-group">
								<label>New Note</label>
								<textarea
									ref={this.notesRef}
									className="form-control"
									value={note}
									onChange={this.handleNoteChange}
								/>
								<span className="help-block m-b-none">{note.length} of 2000</span>
							</div>
						)}
					</div>
					<div className="modal-footer">
						{isAddingNote ? (
							<React.Fragment>
								<Button
									title="Cancel"
									large
									onClick={onClose}
								/>
								<Button
									title="Save"
									onClick={this.handleSave}
									disabled={isSaving || (note.length === 0 || note.length > 2000)}
									large
									primary
									className="ml"
								/>
							</React.Fragment>
						) : (
							<React.Fragment>
								<div className="pull-left">
									<Button
										title="Add Note"
										onClick={this.handleShowNoteField}
										large
										primary
										className="ml"
									/>
								</div>
								<Button
									title="Close"
									large
									onClick={onClose}
								/>
							</React.Fragment>
						)}
					</div>
				</div>
			</Modal>
		);
	}
}
